import {type DeltaQueryTypeOverride} from '../types';

/** URL query key for the admin delta-query override. */
export const DELTA_QUERY_URL_PARAM = 'delta_query';

/**
 * Maps `?delta_query=backend|columnar|bucketed` onto DeltaQueryTypeOverride.
 * Unknown or missing values yield undefined so getQueryType keeps its defaults.
 */
export function parseDeltaQueryUrlParam(
  search: string
): DeltaQueryTypeOverride | undefined {
  const raw = new URLSearchParams(search).get(DELTA_QUERY_URL_PARAM);
  switch (raw) {
    case 'backend':
      return 'backendLines';
    case 'columnar':
      return 'columnar';
    case 'bucketed':
      return 'bucketed';
    default:
      return undefined;
  }
}
